import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useBreakpoints } from "../hooks/useBreakpoints";

import MainLayout from "../layouts/MainLayout";
import AppSubscribe from "../components/global/AppSubscribe";
import blogs from "../components/data/blogs";

const BlogScreen = () => {
  const { md } = useBreakpoints();

  return (
    <MainLayout>
      <div>
        <span className="h-0.5 mx-auto w-12 rounded-full bg-crimson-ffs block mb-1" />
        <h1 className="text-crimson-ffs mx-auto capitalize mb-8 text-center md:w-[500px] lg:w-[800px]">
          Blogs
        </h1>
        <h3 className="container text-crimson-ffs mb-4">New Blogs</h3>
        <div
          className={` ${
            !md
              ? "carousel carousel-center py-4 flex gap-4 px-4 md:px-8"
              : "grid grid-cols-3 container gap-6"
          }`}
        >
          {blogs.map((blog, blogIndex) => (
            <Link
              key={blogIndex}
              to={`blog/${blog.title.toLowerCase().split(" ").join("-")}`}
              className="carousel-item flex-col"
            >
              <div
                className="bg-cover bg-no-repeat w-[300px] md:w-full h-[179px] md:h-[224px] rounded-br-[30px]"
                style={{
                  backgroundImage: `url("${require(`../assets/img/blogs/${blog.title
                    .toLowerCase()
                    .split(" ")
                    .join("-")}.png`)}")`,
                }}
              />
              <p className="w-[300px] lg:w-[310px] xl:w-[320px] font-bold mt-3 lg:text-2xl">
                {blog.title}
              </p>
              <p className="mt-1">{blog.date}</p>
            </Link>
          ))}
        </div>
        <div className="container mt-24 lg:mt-36 grid gap-8">
          <span className="h-0.5 rounded-full bg-denim-ffs opacity-20 block" />
          <div className="lg:w-[80%] lg:mx-auto">
            <div className="flex flex-col md:flex-row md:justify-between">
              <h3 className="text-crimson-ffs mb-8">All Blogs</h3>
              {/* <div className="relative">
                <input
                  type="text"
                  placeholder="Search our blog"
                  className="py-3 px-4 w-full md:w-[375px] border-transparent outline-none rounded-xl mb-8"
                />
                <i
                  className="iconify font-bold absolute right-4 top-4"
                  data-icon="octicon:search-16"
                />
              </div> */}
            </div>
            <div className="grid gap-8 mb-8">
              {blogs.map((blog, blogIndex) => (
                <Link
                  key={blogIndex}
                  to={`blog/${blog.title.toLowerCase().split(" ").join("-")}`}
                  className="md:flex gap-6"
                >
                  <div
                    className="bg-cover bg-no-repeat h-[179px] md:h-[264] md:w-[275px] rounded-br-[20px]"
                    style={{
                      backgroundImage: `url("${require(`../assets/img/blogs/${blog.title
                        .toLowerCase()
                        .split(" ")
                        .join("-")}.png`)}")`,
                    }}
                  />
                  <div>
                    <p className="w-[300px] md:w-full font-bold mt-3  md:text-2xl">
                      {blog.title}
                    </p>
                    <p className="mt-1">{blog.date}</p>
                  </div>
                </Link>
              ))}
            </div>
            <span className="h-0.5 rounded-full bg-denim-ffs opacity-20 block mb-16" />
          </div>
        </div>
        <section className="container w-full">
          <div className="flex flex-col lg:flex-row gap-8 mb-24 items-center justify-between mt-[50px]">
            <div className="w-[100%] lg:w-fit">
              <h3 className="text-crimson-ffs mb-1">Cashflow Compass</h3>
              <span className="text-navy-blue-ffs">
                By Forager Financial Services
              </span>
              <p className="mt-8 mb-4">
                “The tools you need to financial prosperity with practical
                insights and expert guidance.”
              </p>
              <p>
                You will get an email with 2 financial tips and 1 question for
                you to ponder bi-weekly. If you are looking for tailored
                financial solutions for your organization’s mission enter your
                email and sign up for free right now.
              </p>
            </div>
            <div className="w-full xl:w-[500px] h-[400px] md:h-[340px] -order-1 lg:order-2">
              <AppSubscribe />
            </div>
          </div>
        </section>
      </div>
    </MainLayout>
  );
};

export default BlogScreen;
